import { formatDate } from "@/utils/timeRelated";
import { X } from "lucide-react";
import { Email } from "../context/EmailContext";

interface EmailModalProps {
  email: Email;
  onClose: () => void;
}

export const EmailModal = ({ email, onClose }: EmailModalProps) => {
  if (!email) return null;

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50 p-8">
      <div
        className="bg-gradient-to-r from-indigo-50 to-pink-50 w-full max-w-2xl max-h-[80vh] overflow-y-auto 
        rounded-lg border border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]"
      >
        {/* Header */}
        <div className="border-b border-black p-4">
          <div className="flex justify-between items-start gap-4">
            <h2 className="text-lg font-medium text-black tracking-tight">
              Subject: {email.subject}
            </h2>
            <button
              onClick={onClose}
              className="p-1 hover:bg-black/5 rounded-md transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-4 space-y-4">
          {/* Metadata - Now stacked vertically */}
          <div className="space-y-2">
            <span className="block px-3 py-1 bg-white border border-gray-300 rounded-md text-sm  text-gray-500 w-fit">
              To: {email.email}
            </span>
            <span className="block px-3 py-1 bg-white border border-gray-300 rounded-md text-sm  text-gray-500 w-fit">
              Created at: {formatDate(email.created_at)}
            </span>
            <span
              className={`
                  block px-3 py-1 border border-green-500 rounded-md text-sm text-gray-500 w-fit
                ${email.resend_id ? "bg-green-200" : "bg-red-200"}
              `}
            >
              {email.resend_id ? "✓ Delivered" : "Failed"}
            </span>
          </div>

          {/* Email Body */}
          <div className="bg-white border border-black rounded-lg p-8 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]">
            <h2 className="text-lg font-medium text-black tracking-tight">
              <div dangerouslySetInnerHTML={{ __html: email.subject }} />
            </h2>
            <div
              className="prose prose-sm max-w-none"
              dangerouslySetInnerHTML={{ __html: email.body }}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-black p-4">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-black text-white rounded-md text-sm font-medium
                border border-black
                hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]
                hover:translate-x-[-2px] hover:translate-y-[-2px]
                transition-all"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
